<template>
  <div class="detail">
    <div class="content">
      <div class="question">
        <div class="question-dsc">{{ detail.title }} {{ detail.version }}</div>
        <div class="question-time">{{ detail.displayTime | formatDate }}</div>
      </div>
      <div class="answer">
        <div class="answer-dsc" v-html="detail.contents"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex';
export default {
  name: 'DynamicsDetail',
  data() {
    return {
      detail: {
        remark: '如何使用产品？',
        answer: '产品使用方法',
        viewsNumber: 100
      },//问题详情
      btnsList:[
        {
          text: '有帮助',
          icon: require('../../assets/images/client/evaluationUse.png'),
          isHelpful: 1
        },
        {
          text: '无帮助',
          icon: require('../../assets/images/client/evaluationUnuse.png'),
          isHelpful: 2
        }
      ]
    };
  },

  created() {
    const { id } = this.$route.query;
    // 产品动态详情
    this.getDynamicDetails(id);
  },
  filters: {
    // 时间格式化
    formatDate(time) {
      if (!time) return '';
      return moment(time).format('YYYY/MM/DD');
    }
  },
  methods: {
    ...mapActions(['dynamicDetails', 'questionClientFeedback', 'beginnerInfoClientFeedback']),
    // 评价
    handleHelpful(item){
      const { id, type } = this.$route.query;
      if(type === 'quesion'){
        // 问题详情
        this.questionClientFeedback({ id, action: item.isHelpful }).then(res=>{
          this.$message.success('评价成功');
        })
      }else if(type === 'beginner'){
        // 新人入门内容详细信息
        this.beginnerInfoClientFeedback({ id, action: item.isHelpful }).then(res=>{
          this.$message.success('评价成功');
        })
      }
    },
    //  问题详情
    getDynamicDetails(id){
      this.dynamicDetails({ id }).then(res=>{
        this.detail = res;
      })
    }
  },
};
</script>

<style lang="sass" rel="stylesheet/scss" scoped>
.detail{
  min-height: 560px;
  width: 100%;
  display: flex;
  .content{
    background-color: #fff;
    width: 100%;
    padding: 20px;
    .question{
      overflow: hidden;
      margin-bottom: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-dsc,
      &-time{
        font-size: 14px;
        color: #333;
        line-height: 14px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// DynamicsDetail.vue?171693b4